import React, { useState } from "react";
import { colors } from "../common/mixins";

interface InfoIconProps {
  color?: string;
  strokeColor?: string;
}

export const TooltipInfoIcon = ({
  color = colors.primary,
  strokeColor = "white",
}: InfoIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill={color}
      />
      <path
        d="M8.00049 11.1523L8.00049 6.78871"
        stroke={strokeColor}
        strokeWidth="1.47273"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99976 4.23828C7.80156 4.23814 7.64136 4.07714 7.64136 3.87891C7.6415 3.6808 7.80165 3.52065 7.99976 3.52051C8.19799 3.52051 8.35899 3.68071 8.35913 3.87891C8.35913 4.07723 8.19808 4.23828 7.99976 4.23828Z"
        fill="white"
        stroke={strokeColor}
        strokeWidth="0.736364"
      />
    </svg>
  );
};
